var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8363",
    "data-name": "Group 8363",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 11.746,
    viewBox: "0 0 10 11.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 10,
    height: 11.746,
    fill: "#009bdc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8362",
    "data-name": "Group 8362",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M5.093,0A1.435,1.435,0,0,1,5.71.976a3.994,3.994,0,0,1,.118,1.069c0,.51.022,1.02.03,1.53,0,.191,0,.382-.012.572a.173.173,0,0,0,.081.162L7.276,5.3c.021.015.039.035.075.068V4.879h.8v.583a.988.988,0,0,1,0,.206c-.048.222.076.342.237.458.429.307.851.623,1.276.936.1.07.193.139.287.212.024.018.054.049.054.074,0,.3,0,.6,0,.924L5.787,6.534c-.01.114-.025.22-.029.327-.01.281-.014.562-.025.844-.013.348-.03.7-.045,1.045s-.03.712-.045,1.068c-.007.166-.01.333-.026.5a.133.133,0,0,0,.082.141c.377.208.753.417,1.132.621a.112.112,0,0,1,.073.117c0,.176,0,.351,0,.527l0,.023H6.788c-.15-.031-.3-.064-.45-.091-.285-.051-.571-.092-.854-.15a2.061,2.061,0,0,0-.849-.035c-.333.069-.669.123-1,.185-.154.029-.307.061-.461.092H3.1l0-.023c0-.18,0-.359.006-.539a.155.155,0,0,1,.065-.11q.541-.309,1.089-.607a.162.162,0,0,0,.106-.168c-.012-.327-.014-.654-.025-.981-.012-.352-.03-.7-.045-1.056s-.031-.719-.046-1.079c-.007-.17-.013-.341-.024-.511a.962.962,0,0,0-.03-.14L0,8.262c0-.313-.01-.615.008-.915,0-.064.1-.132.166-.181.537-.4,1.078-.791,1.614-1.19a.188.188,0,0,0,.063-.131c.005-.32,0-.641,0-.968h.759v.487c.15-.11.281-.2.41-.3.338-.25.673-.5,1.013-.75a.192.192,0,0,0,.1-.173c0-.4.007-.807.01-1.211,0-.063-.013-.126-.012-.189.006-.346,0-.693.026-1.038a2.948,2.948,0,0,1,.4-1.4A.811.811,0,0,1,4.91,0Z",
    transform: "translate(0)",
    fill: "#009bdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M100.647,383.241l0,.023h-.023l.018-.023",
    transform: "translate(-97.551 -371.518)",
    fill: "#009bdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M225.635,383.265l0-.023.019.023Z",
    transform: "translate(-218.733 -371.519)",
    fill: "#009bdc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneUp);
export default __webpack_public_path__ + "static/media/plane-up.d9c6a8062c2e1f5df6b50575494196e6.svg";
export { ForwardRef as ReactComponent };